module.exports = __webpack_public_path__ + "img/icon_add_g.896eff70.svg";